import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Theme } from '../../../utils/Theme'
import { withStyles } from '@material-ui/styles'
import AuthLayout from '../../layout/AuthLayout'
import * as QueryString from 'query-string'
import { authVerifyEmail } from '../../../redux/actions/authActions'
import Loading from '../../common/Loading'
import EmailVerified from './partials/EmailVerified'
import EmailNotVerified from './partials/EmailNotVerified'

const styles = Theme()

class VerifyEmail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      email: '',
    }
  }

  componentDidMount() {
    const { email, token } = QueryString.parse(this.props.location.search)
    this.setState({email})
    this.props.authVerifyEmail(email, token)
  }
  
  static getDerivedStateFromProps(nextProps) {
    const {loading, emailVerified} = nextProps.auth;
    return {loading, emailVerified}
  }

  render() {
    const { loading, email, emailVerified } = this.state
    const { auth, classes } = this.props
    
    if(loading){
      return (<Loading />)
    }
    
    return (
      <AuthLayout>
        { emailVerified && <EmailVerified classes={classes} />}
        { !emailVerified && <EmailNotVerified email={email} classes={classes} />}
      </AuthLayout>
    )
  }
}

VerifyEmail.propTypes = {
  location: PropTypes.object.isRequired,
  authVerifyEmail: PropTypes.func.isRequired,
  auth: PropTypes.object,
  classes: PropTypes.object,
}

const mapStateToProps = state => ({
  theme: state.theme,
  auth: state.auth,
})
export default connect(mapStateToProps, { authVerifyEmail })(withRouter(withStyles(styles)(VerifyEmail)))
